// extracted by mini-css-extract-plugin
module.exports =  {"button":"e3afc254ff--button--OG_GQ","dark":"e3afc254ff--dark--sPwzU"};